import ActionTable from './ActionTable'

export default ActionTable
